import React from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router';

import {Modal, ModalCancelButton, ModalHeader, ModalSubmitButton} from '@edna/components';

import {useUnblockSupportClientMutation} from 'src/containers/SupportClients/api';
import {BlacklistUndoImage} from 'src/images';

import * as S from './style';

type TProps = {
  closeModal: TEmptyFunction;
};

const ConfirmActivatingModal = React.memo<TProps>(({closeModal}) => {
  const {t} = useTranslation();
  const {id: supportTenantId} = useParams<'id'>();

  const [unblockSupportClient] = useUnblockSupportClientMutation();

  const handleSubmit = React.useCallback(async () => {
    closeModal();

    if (supportTenantId) {
      await unblockSupportClient(supportTenantId);
    }
  }, [closeModal, supportTenantId, unblockSupportClient]);

  return (
    <Modal width="430px">
      <ModalHeader>{t(`ClientStatus:confirmActivatingModal.title`)}</ModalHeader>
      <S.ModalSubHeader>{t(`ClientStatus:confirmActivatingModal.subtitle`)}</S.ModalSubHeader>
      <S.ModalCenterImage as={BlacklistUndoImage} />
      <S.ModalActions>
        <ModalCancelButton onClick={closeModal}>
          {t('ClientStatus:confirmActivatingModal.notNeeded')}
        </ModalCancelButton>
        <ModalSubmitButton onClick={handleSubmit}>{t('Common:button.yes')}</ModalSubmitButton>
      </S.ModalActions>
    </Modal>
  );
});

ConfirmActivatingModal.displayName = 'ConfirmActivatingModal';

export default ConfirmActivatingModal;
